import { render } from "./InClassTeacher.vue?vue&type=template&id=131abd6b"
import script from "./InClassTeacher.vue?vue&type=script&lang=js"
export * from "./InClassTeacher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__